import { useAuth0 } from '@equipmentshare/auth0-react'
import { useEffect, useState } from 'react'

type AuthenticationDetails = {
  accessToken: string,
};

export function useAuthenticationDetails(): AuthenticationDetails {
	const { getAccessTokenSilently } = useAuth0()
	const [ authenticationDetails, setAuthenticationDetails ] =
    useState<AuthenticationDetails>( { accessToken: '' } )

	useEffect( () => {
		let isUnmounted = false
		async function getAuthenticationDetails(): Promise<void> {
			const auth = { accessToken: await getAccessTokenSilently() }
			if ( !isUnmounted ) {
				setAuthenticationDetails( auth )
			}
		}

		getAuthenticationDetails()

		return () => {
			isUnmounted = true
		}
	}, [] )

	return authenticationDetails
}
